import React, {
  useState,
  FunctionComponent,
  useEffect,
  useCallback,
} from 'react';
import styled, { css, keyframes } from 'styled-components';
import axios from 'axios';
import Scroll from 'react-scroll';
import ReactGA from 'react-ga';

import { RenderImageProps } from 'react-photo-gallery';
import { tabImageState } from '../../../modules/tabImage';
import config from '../../../lib/config-api.json';
import { PostConsumptionBodyType } from '../../../lib/common/type';

const { scroller, Element } = Scroll;

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

type StyledType = {
  photo?: {
    src: string;
    srcSet?: string | string[] | undefined;
    sizes?: string | string[] | undefined;
    width: number;
    height: number;
    alt?: string | undefined;
    key?: string | undefined;
  };
  isAfterFirstRender?: boolean;
  isOpen?: boolean;
  leftPixel?: number;
  isEmptyImage?: boolean;
};

const ImageItemComponent = styled.div`
  margin: 3px;
  ${(props: StyledType) => {
    if (props.photo) {
      return css`
        width: ${props.photo.width}px;
      `;
    }
    return css``;
  }}
  ${(props: StyledType) => {
    if (props.isOpen) {
      return css`
        background-color: #e8f0fe;
        border-radius: 6px;
        border: 1px solid;
        border-color: #4285f4;

        /* width: 100%; */

        opacity: 0.5;
      `;
    }
    return css``;
  }}
`;

const ThumbnailBox = styled.div`
  background-color: '#eee';
  overflow: hidden;

  border-radius: 6px;
  ${(props: StyledType) => {
    if (props.photo) {
      return css`
        height: ${props.photo.height}px;
        width: ${props.photo.width}px;
      `;
    }

    return css``;
  }}
  ${(props: StyledType) => {
    if (props.isEmptyImage) {
      return css``;
    }
    return css`
      cursor: pointer;
    `;
  }}
`;

const ThumbnailImage = styled.img`
  /* transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s'; */
  /* border-radius: 6px; */
`;
const ThumbnailTitle = styled.div`
  width: inherit;
  font-family: 'NotoKrR';
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const ThumbnailSource = styled.div`
  font-family: 'NotoKrR';
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

interface ImageItemProps
  extends RenderImageProps<{
    id?: number;
    url?: string;
    src: string;
    width: number;
    height: number;
    targetId?: number;
    alt?: string | undefined;
    title?: string;
    desc?: string;
    source?: string;
  }> {
  onSetSelectPhotoData: (
    selectPhotoData: tabImageState['selectPhotoData']
  ) => void;
  onSetIsDetailViewOpen: (
    isDetailViewOpen: tabImageState['isDetailViewOpen']
  ) => void;
  onPostConsumption: (info: PostConsumptionBodyType) => void;
  selectPhotoData: tabImageState['selectPhotoData'];
}

const ImageItem: FunctionComponent<ImageItemProps> = ({
  index,
  photo,
  onSetSelectPhotoData,
  onSetIsDetailViewOpen,
  onPostConsumption,
  selectPhotoData,
  direction,
  top,
  left,
}: ImageItemProps) => {
  const [isClick, setIsClick] = useState(false);
  const [leftPixel, setLeftPixel] = useState(0);

  useEffect(() => {
    const ElementDetailViewComponent = document.getElementById(
      'detailViewComponent'
    );
    if (ElementDetailViewComponent) {
      setLeftPixel(ElementDetailViewComponent.getBoundingClientRect().left);
    }
  }, []);

  useEffect(() => {
    if (selectPhotoData) {
      if (selectPhotoData.id !== photo.id) {
        setIsClick(false);
      }
    }
  }, [selectPhotoData]);

  const ConsumtionContent = (id: number, targetId: number) => {
    let targets = 'travel_info';
    switch (targetId) {
      case 0:
        targets = 'travel_info';
        break;
      case 1:
        targets = 'recommended_info';
        break;
      case 2:
        targets = 'course_info';
        break;
      default:
        break;
    }
    ReactGA.ga('send', 'event', `click_search_image_image_contents`);
    const data = {
      primary_key: id,
      target: targets,
      document_type: 'image',
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      reaction_type: 0,
      read_type: 0,
    };
    const newData = {
      primary_key: id,
      target: targets,
      document_type: 'image',
      read_type: 0,
    };
    onPostConsumption(newData);
    axios({
      method: 'post',
      url: `${apiInfo.api_url}/read/`,
      timeout: 10000,
      data,
    });
  };

  const MoveToScroll = () => {
    if (selectPhotoData) {
      scroller.scrollTo(`aivoryClickImage${selectPhotoData.src}`, {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: -100,
      });
    }
  };

  const onThumbnailClick = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ): void | undefined => {
    setIsClick(!isClick);

    const selectPhotoDataTemp = {
      id: photo.id || 0,
      url: photo.url || '',
      src: photo.src,
      title: photo.title,
      desc: photo.desc,
      source: photo.source,
      index,
    };
    ConsumtionContent(photo.id || 0, photo.targetId || 0);

    if (selectPhotoData) {
      if (selectPhotoData.id === photo.id) {
        onSetIsDetailViewOpen(false);
        onSetSelectPhotoData(null);
      } else {
        onSetSelectPhotoData(selectPhotoDataTemp);
        onSetIsDetailViewOpen(true);
      }
    } else {
      onSetSelectPhotoData(selectPhotoDataTemp);
      onSetIsDetailViewOpen(true);
    }

    // if (selectPhotoData) {
    //   setTimeout(() => {
    //     scroller.scrollTo(`aivoryClickImage${selectPhotoData.src}`, {
    //       duration: 1500,
    //       delay: 100,
    //       smooth: true,
    //       offset: -100,
    //     });
    //   }, 0);
    // }
  };

  return (
    <ImageItemComponent photo={photo} isOpen={isClick}>
      <Element name={`aivoryClickImage${photo.src}`} />

      {photo.src === '' ? (
        <ThumbnailBox photo={photo} isOpen={isClick} isEmptyImage />
      ) : (
        <ThumbnailBox photo={photo} isOpen={isClick} isEmptyImage={false}>
          <ThumbnailImage
            alt=""
            src={photo.src}
            width={photo.width}
            height={photo.height}
            onClick={onThumbnailClick}
          />
        </ThumbnailBox>
      )}

      {photo.title ? (
        <ThumbnailTitle
          dangerouslySetInnerHTML={{
            __html: photo.title,
          }}
        />
      ) : null}

      <ThumbnailSource>{photo.source}</ThumbnailSource>
    </ImageItemComponent>
  );
};

export default ImageItem;
